module.exports = __webpack_public_path__ + "img/sideOrange.8b1096bd.png";